import React from "react";
import { Button, Grid, Typography, Link, Divider } from "@material-ui/core";
import { makeStyles, CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import Close from "@material-ui/icons/Close";
import { store } from "../../../../helpers";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import { history } from "../../../../helpers";
import { routePaths } from "../../../config/route-paths";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  cancel: {
    color: theme?.palette?.ePrimary?.base,
    marginTop: "0.25rem",
  },
  submit: {
    backgroundColor: theme?.palette?.ePrimary?.base,
    color: theme?.palette?.eWhite?.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme?.palette?.ePrimary?.hover,
    },
    padding: "3% 25%",
    marginLeft: "1rem",
    marginRight: "5rem",
  },
  container: {
    justifyContent: "right",
    align: "right",
  },
  dialogTitle: {
    color: theme?.palette?.eWhite?.base,
    backgroundColor: theme?.palette?.ePrimary?.base,
  },
  crossButton: {
    color: theme?.palette?.eWhite?.base,
    position: "absolute",
    right: 8,
    top: 15,
  },
  alertIcon: {
    width: "4rem",
    height: "auto",
    display: "block",
    margin: "1rem auto",
    color: theme?.palette?.eTertiary?.base,
  },
  yes: {
    backgroundColor: theme?.palette?.ePrimary?.base,
    color: theme?.palette?.eWhite?.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme?.palette?.ePrimary?.hover,
    },
    padding: "3% 35%",
  },
  no: {
    color: theme?.palette?.ePrimary?.base,
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  alert: {
    marginTop: "0.5rem",
  },
  circularProgressColor: {
    color: theme?.palette?.eWhite?.base,
  },
}));
export default function EConfirmation(props) {
  const summaryClass = useStyles();
  const {t:content, ready: contentReady} = useTranslation("content-E_SUMMARY_REVIEW");
  const summaryReviewLabel = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW
  );
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const backCall = () => {
    history.push(routePaths?.LOGIN);
  };
  const primaryLanguage = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );

  return (
    <>
      <Divider className={summaryClass.divider} />
      <Grid container className={summaryClass.container}>
        <Grid item>
          <Link
            component="button"
            onClick={() => {
              handleClickOpen();
            }}
            underline="hover"
            className={summaryClass.cancel}
          >
            <Typography variant="subtitle2">
              <b>{summaryReviewLabel?.E_CANCEL_LABEL}</b>
            </Typography>
          </Link>
        </Grid>
        <Grid item>
          <Button
            className={summaryClass.submit}
            size="small"
            align="right"
            onClick={() => {
              props.submitHandler();
            }}
          >
            <Typography variant="button">
              {summaryReviewLabel?.E_SUBMIT_LABEL}
            </Typography>
            {props.loading ? (
              <CircularProgress
                size={19}
                className={summaryClass.circularProgressColor}
              />
            ) : null}
          </Button>
        </Grid>
      </Grid>
      <Grid>
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle className={summaryClass.dialogTitle}>
            <Typography variant="subtitle1">
              {summaryReviewLabel?.E_CONFIRMATION_LABEL}
            </Typography>
            <Button
              startIcon={<Close />}
              onClick={handleClose}
              className={summaryClass.crossButton}
            ></Button>
          </DialogTitle>
          <DialogContent dividers>
            <WarningRoundedIcon className={summaryClass.alertIcon} />
            <Typography
              className={summaryClass.detailsSubLine}
              dangerouslySetInnerHTML={{
                __html: contentReady ? content("E_SUMMARY_REVIEW_CONFIRMATION").answer : "",
              }}
            ></Typography>
          </DialogContent>
          <DialogActions>
            <Grid item xs={1} sm={1}>
              <Link
                component="button"
                onClick={() => {
                  handleClose();
                }}
                underline="hover"
                className={summaryClass.no}
              >
                <Typography variant="button">
                  {summaryReviewLabel?.E_NO_LABEL}
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Button
                className={summaryClass.yes}
                size="small"
                align="right"
                onClick={backCall}
              >
                <Typography variant="button">
                  {summaryReviewLabel?.E_YES_LABEL}
                </Typography>
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}